<template>
  <v-card color="#EEEEEE" data-test-name="region">
    <RegionHeaderRow :name="name" :price="current.prices?.['energy']" :previous-price="previous.prices?.['energy']" :flags="current.prices" :ap="ap" />
    <v-row no-gutters class="flex-nowrap">
      <v-sheet color="transparent">
        <img src="../images/fcas-raise.png" style="height: 110px; padding-right: 2px" alt="fcas-raise" />
      </v-sheet>
      <v-col class="mt-0">
        <RegionFcasRow
          market="Reg"
          :name="name"
          :raise="current.prices?.['raiseReg']"
          :lower="current.prices?.['lowerReg']"
          :previous-raise="previous.prices?.['raiseReg']"
          :previous-lower="previous.prices?.['lowerReg']"
          :prices="current.prices"
        />
        <RegionFcasRow
          market="1s"
          :name="name"
          :raise="current.prices?.['raise1Sec']"
          :lower="current.prices?.['lower1Sec']"
          :previous-raise="previous.prices?.['raise1Sec']"
          :previous-lower="previous.prices?.['lower1Sec']"
          :prices="current.prices"
        />
        <RegionFcasRow
          market="6s"
          :name="name"
          :raise="current.prices?.['raise6Sec']"
          :lower="current.prices?.['lower6Sec']"
          :previous-raise="previous.prices?.['raise6Sec']"
          :previous-lower="previous.prices?.['lower6Sec']"
          :prices="current.prices"
        />
        <RegionFcasRow
          market="60s"
          :name="name"
          :raise="current.prices?.['raise60Sec']"
          :lower="current.prices?.['lower60Sec']"
          :previous-raise="previous.prices?.['raise60Sec']"
          :previous-lower="previous.prices?.['lower60Sec']"
          :prices="current.prices"
        />
        <RegionFcasRow
          market="5m"
          :name="name"
          :raise="current.prices?.['raise5Min']"
          :lower="current.prices?.['lower5Min']"
          :previous-raise="previous.prices?.['raise5Min']"
          :previous-lower="previous.prices?.['lower5Min']"
          :prices="current.prices"
        />
      </v-col>
      <v-sheet color="transparent">
        <img src="../images/fcas-lower.png" style="height: 110px; padding-left: 2px" alt="fcas-lower" />
      </v-sheet>
    </v-row>
  </v-card>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import RegionFcasRow from '@/components/RegionFcasRow.vue';
import RegionHeaderRow from '@/components/RegionHeaderRow.vue';
import { RegionSnapshot } from '@/repositories';
import HeatMap from '@/heatMaps/heatMap';

export default defineComponent({
  name: 'RegionComponent',
  components: {
    RegionHeaderRow,
    RegionFcasRow
  },
  props: {
    name: { type: String, default: '' },
    current: { type: RegionSnapshot, default: new RegionSnapshot() },
    previous: { type: RegionSnapshot, default: new RegionSnapshot() },
    ap: Boolean,
    heatMap: { type: HeatMap, default: new HeatMap([]) }
  }
});
</script>
